const styles = theme => ({
    alertPanel: {
        width: '100%',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
        marginLeft: 'auto',
        marginRight: 'auto'
    }
});

export default styles;